import React from "react";
import { useLoading } from "contexts/loading-context";

export default function LoadingBar() {
    const { isLoading } = useLoading();

    if (!isLoading) return null;

    return (
        <div
            className="fixed top-0 left-0 z-[9999] w-full h-[3px] bg-gobbyblue overflow-hidden"
            role="progressbar"
            aria-busy="true"
            aria-label="Processing"
        >
            <div
                className="h-full bg-white/60"
                style={{
                    animation: "loading-bar-slide 1.5s ease-in-out infinite",
                    width: "40%",
                }}
            />
        </div>
    );
}
